<template>
	<div class="page">
		<van-nav-bar :title="xuanfeidata.xuanfei_name || $t('concubine.concubine')" class="nav-bar">
			<template #left>
				<van-icon name="arrow-left" color="#fff" @click="back()" />
			</template>
		</van-nav-bar>

		<div class="box">
			<p class="name">{{ xuanfeidata.xuanfei_name }}</p>

			<div class="tag-list" v-if="tagList.length">
				<span class="tag-item" v-for="(tag, index) in tagList" :key="index">
					{{ tag }}
				</span>
			</div>

			<div class="title" v-else>
				{{ xuanfeidata.vo_title }}
			</div>

			<div class="img-list" v-if="imgList.length">
				<van-image
					v-for="(v, k) in imgList"
					:key="k"
					class="detail-img"
					width="98%"
					fit="contain"
					:src="formatImg(v)"
				>
					<template #loading>
						<div class="img-loading">{{ $t('common.loading') }}</div>
					</template>
					<template #error>
						<div class="img-error">{{ $t('common.image_load_fail') }}</div>
					</template>
				</van-image>
			</div>

			<div class="img-empty" v-else>{{ $t('common.no_images_yet') }}</div>

			<van-button
				round="true"
				@click="yuyue"
				class="button"
				color="linear-gradient(to right, #7f5778 , #e5c2a0)"
			>
				{{ $t("concubine.appointment") }}
			</van-button>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			xuanfeidata: {}
		};
	},
	computed: {
		imgList() {
			const val = this.xuanfeidata.img_url;

			if (!val) return [];

			if (Array.isArray(val)) {
				return val.filter(Boolean);
			}

			if (typeof val === 'string') {
				const str = val.trim();

				if (!str) return [];

				// JSON 数组字符串
				if (str.startsWith('[') && str.endsWith(']')) {
					try {
						const arr = JSON.parse(str);
						return Array.isArray(arr) ? arr.filter(Boolean) : [];
					} catch (e) {
						console.warn('img_url parse error', e);
					}
				}

				// 逗号分隔
				if (str.includes(',')) {
					return str.split(',').map(item => item.trim()).filter(Boolean);
				}

				// 单张
				return [str];
			}

			return [];
		},
		tagList() {
			const lang = localStorage.getItem('lang') || 'ja';

			if (this.xuanfeidata.flag) {
				const raw = String(this.xuanfeidata.flag);
				const parts = raw.split('|');
				let text = '';

				if (lang === 'zh') {
					text = parts[0] || '';
				} else if (lang === 'en') {
					text = parts[1] || '';
				} else if (lang === 'ja') {
					text = parts[2] || '';
				} else {
					text = parts[3] || parts[0] || '';
				}

				return text
					.split(/[，,、]/)
					.map(item => item.trim())
					.filter(Boolean);
			}

			if (this.xuanfeidata.vo_title) {
				return String(this.xuanfeidata.vo_title)
					.split(/[，,、]/)
					.map(item => item.trim())
					.filter(Boolean);
			}

			return [];
		}
	},
	methods: {
		back() {
			this.$router.push({
				path: 'list?id=' + this.$route.query.adsid + '&name=' + this.$route.query.name
			});
		},
		getxuanfeidata() {
			this.$http({
				method: 'get',
				url: 'xuanfeidata',
				data: { id: this.$route.query.id }
			}).then(res => {
				this.xuanfeidata = res.data || {};
				console.log('xuanfeidata =', this.xuanfeidata);
			});
		},
		formatImg(url) {
			if (!url) return '';
			if (typeof url !== 'string') return '';
			if (url.startsWith('http://') || url.startsWith('https://')) return url;
			return url;
		},
		yuyue() {
			this.$toast(this.$t("reservation.counselor"));
		}
	},
	created() {
		this.getxuanfeilist();
	}
};
</script>

<style scoped>
.box {
	width: 94%;
	margin: 0 auto;
	text-align: center;
	padding-bottom: 6.25rem;
}

.name {
	font-size: 1.35rem;
	margin: 1rem 0 0.5rem;
	color: #333;
	font-weight: 600;
}

.title {
	font-size: 0.9rem;
	color: #777;
	line-height: 1.6;
	margin-bottom: 1rem;
	word-break: break-word;
}

.tag-list {
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	gap: 0.5rem;
	margin: 0.8rem 0 1.2rem;
}

.tag-item {
	display: inline-block;
	padding: 0.35rem 0.75rem;
	border-radius: 999px;
	font-size: 0.78rem;
	color: #fff;
	background: linear-gradient(90deg, #b36be3, #e24b8b);
	line-height: 1;
	box-shadow: 0 2px 6px rgba(0,0,0,0.08);
}

.img-list {
	width: 100%;
}

.detail-img {
	display: block;
	margin: 0 auto 0.9rem;
	background: #fafafa;
	border-radius: 12px;
	overflow: hidden;
	box-shadow: 0 2px 8px rgba(0,0,0,0.08);
}

::v-deep .detail-img .van-image__img {
	display: block;
	width: 100%;
	height: auto;
}

.img-loading,
.img-error,
.img-empty {
	width: 100%;
	min-height: 12rem;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 0.85rem;
	color: #999;
	background: #f7f7f7;
	border-radius: 10px;
}

.button {
	width: 11rem;
	height: 2.7rem;
	font-size: 1rem;
	margin-top: 1rem;
	border-radius: 30px;
	box-shadow: 0 4px 10px rgba(0,0,0,0.12);
}
</style>